import React, { useEffect, useRef, useState } from 'react'
import { 
  ExperienceCard,
  CompanyLogo,
  CardHeader,
  JobTitle,
  CompanyDateContainer,
  CompanyName,
  CompanyDate,
  ExpandButtonContainer,
  DividerLine,
  StyledIconButton,
  CollapseContent,
  BulletPointsList,
  BulletPointItem
} from './Experience.styles'
import { Collapse } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

function CardComponent(props) {
  const [showMore, setShowMore] = useState(false);
  const ref = useRef(null) 

  useEffect(() => {
    const observer = new IntersectionObserver((entrys) => {

    })

    const current = ref.current;
    if(current) observer.observe(current)
  }, [])

  return (
    <ExperienceCard ref={ref} className={showMore ? 'expanded' : ''}>
      <CompanyLogo
        src={props.companyLogo}
        alt={props.company}
      />
      <CardHeader>
        <JobTitle>{props.jobTitle}</JobTitle>
        <CompanyDateContainer>
          <CompanyName>
            {props.company}
          </CompanyName>
          <CompanyDate>
            {props.date}
          </CompanyDate>
        </CompanyDateContainer>
      </CardHeader>

      <ExpandButtonContainer>
        <DividerLine />

        <StyledIconButton
          onClick={() => setShowMore(!showMore)}
          $showMore={showMore}
        >
          <ExpandMoreIcon />
        </StyledIconButton>

        <DividerLine />
      </ExpandButtonContainer>

      <Collapse in={showMore} timeout={400}>
        <CollapseContent>
          <BulletPointsList>
            {props.bulletPoints.map((bulletPoint, idx) => (
              <BulletPointItem
                key={idx}
              >
                {bulletPoint}
              </BulletPointItem>
            ))}
          </BulletPointsList>
        </CollapseContent>
      </Collapse>
    </ExperienceCard>
  )
}

export default CardComponent